export enum HighwayWatchListStatusId {
  ActiveAlert = 1,
  HeldExpiredAlert = 2,
  HeldAlert = 3,
  Ignored = 4,
}

export enum HighwayFraudIndicatorLevelId {
  Pass = 1,
  Fail = 2,
  NotAvailable = 3,
}
